export default {
  "activityBonusHistory.title": "活动奖励历史",
  "activityBonusHistory.copySuccess": "复制成功！",

  "activityBonusHistory.search.createTime": "创建时间",
  "activityBonusHistory.search.rewardType": "派发类型",
  "activityBonusHistory.search.status": "状态",

  "activityBonusHistory.column.index": "序号",
  "activityBonusHistory.column.activityBonusId": "活动奖励ID",
  "activityBonusHistory.column.userno": "用户编号",
  "activityBonusHistory.column.email": "邮箱",
  "activityBonusHistory.column.bonusAmount": "奖励金额",
  "activityBonusHistory.column.bonusWager": "流水要求",
  "activityBonusHistory.column.activityId": "活动ID",
  "activityBonusHistory.column.activityType": "活动类型",
  "activityBonusHistory.column.rewardType": "派发类型",
  "activityBonusHistory.column.status": "状态",
  "activityBonusHistory.column.operator": "操作人",
  "activityBonusHistory.column.createTime": "创建时间",
  "activityBonusHistory.column.gem": "宝石",
};